import React from 'react';
import { InstagramIcon, MailIcon, MountainIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="bg-[#112a23] text-white" data-id="element-175">
      <div className="mx-auto max-w-[1440px] px-5 py-16 sm:px-8 lg:px-12 lg:py-20" data-id="element-176">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_0.8fr_0.8fr_1fr]" data-id="element-177">
          <div data-id="element-178">
            <div className="flex items-center gap-2.5" data-id="element-179">
              <span className="flex h-10 w-10 items-center justify-center rounded-full border border-white/35" data-id="element-180">
                <MountainIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-181" />
              </span>
              <span className="font-serif text-xl tracking-[0.08em]" data-id="element-182">
                MANASLU
              </span>
            </div>
            <p className="mt-6 max-w-xs text-sm leading-6 text-white/65" data-id="element-183">
              Thoughtfully led Himalayan journeys, rooted in respect for
              mountain, culture, and community.
            </p>
          </div>
          <div data-id="element-184">
            <h3 className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#d8a75a]" data-id="element-185">
              Explore
            </h3>
            <div className="mt-5 flex flex-col gap-3 text-sm text-white/75" data-id="element-186">
              <a href="#treks" className="hover:text-white" data-id="element-187">
                All treks
              </a>
              <a href="#guide" className="hover:text-white" data-id="element-188">
                Trekking guide
              </a>
              <a href="#stories" className="hover:text-white" data-id="element-189">
                Field stories
              </a>
            </div>
          </div>
          <div data-id="element-190">
            <h3 className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#d8a75a]" data-id="element-191">
              Kathmandu
            </h3>
            <address className="mt-5 not-italic text-sm leading-6 text-white/75" data-id="element-192">
              Thamel, Kathmandu
              <br data-id="element-193" />
              Nepal 44600
              <br data-id="element-194" />
              <a href="tel:+9779812345678" className="hover:text-white" data-id="element-195">
                +977 981 234 5678
              </a>
            </address>
          </div>
          <div data-id="element-196">
            <h3 className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#d8a75a]" data-id="element-197">
              Begin your journey
            </h3>
            <a href="mailto:hello@manaslutrekking.com" className="mt-5 flex items-center gap-3 font-serif text-xl hover:text-[#f2ca80]" data-id="element-198">
              <MailIcon className="h-4 w-4" data-id="element-199" /> hello@manaslutrekking.com
            </a>
            <div className="mt-7 flex gap-3" data-id="element-200">
              <a href="#stories" aria-label="Instagram" className="flex h-9 w-9 items-center justify-center border border-white/25 hover:border-[#d8a75a] hover:text-[#d8a75a]" data-id="element-201">
                <InstagramIcon className="h-4 w-4" data-id="element-202" />
              </a>
              <a href="#videos" aria-label="YouTube" className="flex h-9 w-9 items-center justify-center border border-white/25 hover:border-[#d8a75a] hover:text-[#d8a75a]" data-id="element-203">
                <YoutubeIcon className="h-4 w-4" data-id="element-204" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-16 flex flex-col justify-between gap-4 border-t border-white/15 pt-6 text-[10px] uppercase tracking-[0.15em] text-white/45 sm:flex-row" data-id="element-205">
          <p data-id="element-206">© 2026 Manaslu Trekking. Nepal.</p>
          <p data-id="element-207">Walk lightly. Travel deeply.</p>
        </div>
      </div>
    </footer>;
}